/* TODO: t() */
import React from 'react';
import FormElementBase from '../FormElementBase';

import FieldEditor from './AddonElement/AddonElementFieldEditorView';
import FormView from './AddonElement/AddonElementFormView';
import ReadOnlyView from './AddonElement/AddonElementReadOnlyView';
import EditView from './AddonElement/AddonElementEditView';

import IndexedList from '../../../support/shared/IndexedList';
import { Market } from '../../../types/shared/Market';
import { AddonElementDefinition } from '../../../types/shared/FormFieldDefinition';
import { VendorAddons, Field } from '../../../types/shared/Vendor';
import { Addon } from '../../../types/shared/Addon';

export type MarketDateSelections = {
  [key: string]: { market: Market; date: string };
};

type ReadOnlyViewProps = {
  isAdmin: boolean;
  value: VendorAddons | null | undefined;
  // onFileClick: (file: FileDesc, event: Event) => void;
  isLoading: boolean;
  markets: IndexedList<Market>;
  // TODO: Make this prop required and add it to the other elements ReadOnlyViewProps
  addons?: Map<string, Addon> | null | undefined;
  fields: IndexedList<Field>;
};

type FormViewProps = {
  markets?: IndexedList<Market> | null | undefined;
  addons?: Map<string, Addon> | null | undefined;
  onChange?: (id: string, value: VendorAddons) => void;
  readOnly?: boolean;
  value?: VendorAddons;
};

type EditViewProps = {
  value?: VendorAddons;
  onChange: (id: string, value: VendorAddons) => void;
  markets: IndexedList<Market>;
  addons?: Map<string, Addon> | null | undefined;
  fields: IndexedList<Field>;
  isVendor?: boolean;
};

class AddonElement extends FormElementBase {
  static getType() {
    return 'AddonElement';
  }

  static getDescription() {
    return 'Addon Element';
  }

  static getAttributes() {
    return {
      name: 'Addon Element',
      label: 'Addon Element',
      hidden: false,
      is_required: false,
      is_public: false,
      disableSelectAll: false,
    };
  }

  renderFieldEditor(props: { addons?: Map<string, Addon> | null | undefined }) {
    let { addons } = props;
    return (
      <FieldEditor
        key={this.id}
        ref="field-editor"
        parent={this}
        addons={addons}
      />
    );
  }

  renderFieldView(props?: {
    markets?: IndexedList<Market> | null | undefined;
    addons?: Map<string, Addon> | null | undefined;
  }) {
    let { markets, addons } = props || {};
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as AddonElementDefinition}
        markets={markets}
        readOnly={true}
        addons={addons}
      />
    );
  }

  renderFormView(props?: FormViewProps) {
    props = props || {};
    // TODO: Replace ref={this.id} (was removed for functional component)
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as AddonElementDefinition}
        {...props}
      />
    );
  }

  renderReadOnlyView(props: ReadOnlyViewProps) {
    let { isAdmin, value, fields } = props;
    return (
      <ReadOnlyView
        key={this.id}
        definition={this.definition as AddonElementDefinition}
        isAdmin={isAdmin}
        value={value}
        fields={fields}
      />
    );
  }

  renderEditView(props: EditViewProps) {
    let definition = this.definition as AddonElementDefinition;
    let { value, onChange, markets, addons, fields, isVendor } = props;
    return (
      <EditView
        key={this.id}
        definition={definition}
        value={
          // This is hacky, but in some cases the value got stored with an `addonId` of empty string
          {
            addonId: definition.id,
            status: value?.status ?? 'No',
            dates: value?.dates ?? {},
          }
        }
        onChange={onChange}
        markets={markets}
        addons={addons}
        fields={fields}
        isVendor={isVendor}
      />
    );
  }
}

export default AddonElement;
